import React, { ReactNode, createContext, useContext, useState } from 'react';

interface LayoutContextType {
  showHeader: boolean;
  showSidebar: boolean;
  setShowHeader: (show: boolean) => void;
  setShowSidebar: (show: boolean) => void;
  hideAll: () => void;
  showAll: () => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [showHeader, setShowHeader] = useState(true);
  const [showSidebar, setShowSidebar] = useState(true);

  const hideAll = () => {
    setShowHeader(false);
    setShowSidebar(false);
  };

  const showAll = () => {
    setShowHeader(true);
    setShowSidebar(true);
  };

  return (
    <LayoutContext.Provider
      value={{
        showHeader,
        showSidebar,
        setShowHeader,
        setShowSidebar,
        hideAll,
        showAll,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = (): LayoutContextType => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
